import { InjectionToken } from '@angular/core';
/**
 * A token that specifies the text direction of Kendo UI for Angular components.
 *
 * @example
 * {% embed_file rtl/app.module.ts preview %}
 * {% embed_file rtl/app.component.ts %}
 * {% embed_file shared/main.ts hidden %}
 *
 */
export var RTL = new InjectionToken("Kendo UI Right-to-Left token");



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-angular-l10n/dist/es/rtl.js
// module id = ../../../../@progress/kendo-angular-l10n/dist/es/rtl.js
// module chunks = vendor